module.exports = __webpack_public_path__ + "Icono_ProgramarCXMenu_126px.png";